// extracted by mini-css-extract-plugin
export default {"wrapper":"ButtonInstance_wrapper__rIpHU"};